import { useContext } from 'react'
import { AuthContext as ProviderContext } from './AuthProvider'

export {
	AUTH_QUERY_KEY,
	AuthContext,
	type AuthContextValue,
	AuthProvider,
} from './AuthProvider'

export function useAuth() {
	const ctx = useContext(ProviderContext)
	if (!ctx) {
		throw new Error('useAuth must be used inside <AuthProvider>')
	}
	return ctx
}
